"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var dropdown_1 = tslib_1.__importDefault(require("@patternfly/react-styles/css/components/Dropdown/dropdown"));

var dropdownConstants_1 = require("./dropdownConstants");

var DropdownWithContext_1 = require("./DropdownWithContext");

exports.Dropdown = function (_a) {
  var _onSelect = _a.onSelect,
      ref = _a.ref,
      ouiaId = _a.ouiaId,
      ouiaSafe = _a.ouiaSafe,
      props = tslib_1.__rest(_a, ["onSelect", "ref", "ouiaId", "ouiaSafe"]);

  return React.createElement(dropdownConstants_1.DropdownContext.Provider, {
    value: {
      onSelect: function onSelect(event) {
        return _onSelect && _onSelect(event);
      },
      toggleTextClass: dropdown_1["default"].dropdownToggleText,
      toggleIconClass: dropdown_1["default"].dropdownToggleImage,
      toggleIndicatorClass: dropdown_1["default"].dropdownToggleIcon,
      menuClass: dropdown_1["default"].dropdownMenu,
      itemClass: dropdown_1["default"].dropdownMenuItem,
      toggleClass: dropdown_1["default"].dropdownToggle,
      baseClass: dropdown_1["default"].dropdown,
      baseComponent: 'div',
      sectionClass: dropdown_1["default"].dropdownGroup,
      sectionTitleClass: dropdown_1["default"].dropdownGroupTitle,
      sectionComponent: 'section',
      disabledClass: dropdown_1["default"].modifiers.disabled,
      plainTextClass: dropdown_1["default"].modifiers.text,
      ouiaId: ouiaId,
      ouiaSafe: ouiaSafe,
      ouiaComponentType: exports.Dropdown.displayName
    }
  }, React.createElement(DropdownWithContext_1.DropdownWithContext, Object.assign({}, props)));
};

exports.Dropdown.displayName = 'Dropdown';